import { TranslateService } from './../../shared/translate/translate.service';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'wego-driver-role',
  template: `
  <div class="driver-role">
    <div class="wrapper">
      <wego-driver-navbar [menu]="menu"></wego-driver-navbar>
      <div class="page-content">
        <router-outlet></router-outlet>
      </div>
      <wego-driver-footer></wego-driver-footer>
    </div>
  </div>
  `
})

export class DriverRoleComponent implements OnInit, OnDestroy {
  menu: any = [
    {
      title: 'LblHome',
      icon: 'fa fa-home fa-fw',
      redirectPath: 'dashboard',
    },
    {
      title: 'LblOverview',
      icon: 'fa fa-list fa-fw',
      redirectPath: 'booking/overview',
    },
    {
      title: 'LblNormal',
      icon: 'fa fa-calendar fa-fw',
      redirectPath: 'booking',
    },
    {
      title: 'LblHistory',
      icon: 'fa fa-clock-o fa-fw',
      redirectPath: 'booking/history',
    },
    {
      title: 'LblTripHistory',
      icon: 'fa fa-map fa-fw',
      redirectPath: 'trip/history',
    },
    {
      title: 'LblCostAndExpenses',
      icon: 'fa fa-book fa-fw',
      redirectPath: 'drivercostexpense/list',
    },
    {
      title: 'LblSubscription',
      icon: 'fa fa-tags fa-fw',
      redirectPath: 'subscription/list',
    }

  ];
  constructor(private translate: TranslateService) { }
  ngOnInit() {
    this.translate.setDetectedLang();
  }

  ngOnDestroy() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/role/components/driver-role.component.ts